/**
 * figure.tsx — a figure as the game's formatters write it. A dash is how they
 * write nothing — no quarter yet, a line that cost nothing — and it is set in
 * the caption ink, so it reads as blank rather than as a number. `strong` sets
 * a figure a statement ends on — ending cash, equity — in the firmer weight.
 * `onNight` sets the dash for a night board, in the board's label ink.
 *
 *   <Figure text={formatStatementCash(balance.equity)} strong />
 *
 * StatementRow and Table set a string value through it, so a statement line or
 * a cell that holds a dash needs nothing of its own.
 */

import { EM_DASH } from '../../utils/format';
import styles from './figure.module.css';

export function Figure({ text, strong = false, onNight = false }: { text: string; strong?: boolean; onNight?: boolean }) {
  if (text === EM_DASH) {
    return <span className={[styles.blank, onNight ? styles.onNight : ''].filter(Boolean).join(' ')}>{EM_DASH}</span>;
  }
  return strong ? <span className={styles.strong}>{text}</span> : <>{text}</>;
}
